import { useEffect, useState } from 'react';
import { FormTextInput } from './forms';
import { fetchSsoLoginOptions, ssoStartUrl, SsoLoginOptions } from '../lib/auth';

const EMAIL_SHAPE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

const LoginForm: (props: {
  onSubmit: (result: { email: string; password: string }) => any;
}) => JSX.Element = ({ onSubmit }) => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [sso, setSso] = useState<SsoLoginOptions | null>(null);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const trimmed = email.trim();
    if (!EMAIL_SHAPE.test(trimmed)) {
      setSso(null);
      return;
    }
    let cancelled = false;
    const timer = setTimeout(async () => {
      const options = await fetchSsoLoginOptions(trimmed);
      if (!cancelled) setSso(options && options.ssoAvailable ? options : null);
    }, 400);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [email]);

  const ssoRequired = Boolean(sso && sso.ssoRequired);
  const providerLabel = (sso && sso.providerName) || 'your organisation';

  const startSso = () => {
    const url = ssoStartUrl(sso ? sso.startUrl : null);
    if (!url) return;
    setLeaving(true);
    window.location.assign(url);
  };

  return (
    <div className="login-form">
      <FormTextInput
        id="login_imput"
        name="email"
        type="email"
        onChange={(text) => {
          setEmail(text);
        }}
        placeholder="Email"
      ></FormTextInput>
      {ssoRequired ? (
        <div className="form-element">
          Your organisation signs in to Audalize with {providerLabel}.
        </div>
      ) : (
        <FormTextInput
          id="pw_imput"
          name="password"
          type="password"
          onChange={(text) => {
            setPassword(text);
          }}
          placeholder="Password"
        ></FormTextInput>
      )}

      <div className="form-element">
        {ssoRequired ? (
          <button style={{ width: '100%' }} disabled={leaving} type="submit" onClick={startSso}>
            <div>Continue with {providerLabel}</div>
          </button>
        ) : (
          <button
            style={{ width: '100%' }}
            disabled={!email || !password || leaving}
            type="submit"
            onClick={() => {
              email && password && onSubmit({ email, password });
            }}
          >
            <div>Login to Audalize</div>
          </button>
        )}
      </div>

      {sso && !ssoRequired && (
        <div className="form-element">
          <button style={{ width: '100%' }} disabled={leaving} type="button" onClick={startSso}>
            <div>Sign in with {providerLabel}</div>
          </button>
        </div>
      )}
    </div>
  );
};

export { LoginForm };
